import { Box } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";

import { listingURL } from "../api/apis";
import { useDebouncedSearch } from "../hooks/useDebouncedSearch";
import { filterActiveListings, filterListingsWithPhotos } from "../actions";
import { SearchComp } from "./newProfessionals/SearchBar/Search";

const PropertySearch = (props) => {
  const navigate = useNavigate();

  const [value, setValue] = useState("");
  const [searchLoad, setSearchLoad] = useState(false);
  const [searchResult, setSearchResult] = useState();
  const [resType, setResType] = useState();
  const [recentSearch, setRecentSearch] = useState([]);

  const getSearchLocation = (val) => {
    //eslint-disable-next-line no-undef
    new google.maps.places.PlacesService(
      document.getElementById("map")
    ).findPlaceFromQuery(
      { query: val, fields: ["name", "formatted_address"] },
      (resPlaces) => {
        localStorage.setItem("places", JSON.stringify(resPlaces));
      }
    );
  };

  const searchFilter = async (e) => {
    e.stopPropagation();
    // if (filterInput.search === "") {
    //   return;
    // }
    // else {
    // }
    if (resType === "address") {
      navigate(
        `/listing/${searchResult[0]?.mlsId}/details/${
          searchResult[0]?.listing === "mls" ? "mls" : "crmls"
        }`
      );
    }
    if (resType === "city") {
      const places = JSON.parse(localStorage.getItem("places"));
      navigate(
        `/homes-for-sale/${_.startCase(
          searchResult[0]?.address?.city || places[0]?.name
        )?.toLowerCase()}`
      );
    }
  };

  const onSearchHandler = useDebouncedSearch(
    setValue,
    setSearchLoad,
    setSearchResult,
    setRecentSearch,
    setResType,
    listingURL,
    filterActiveListings,
    filterListingsWithPhotos,
    getSearchLocation,
    props.type
  );

  return (
    <Box {...props}>
      <SearchComp
        type={resType}
        searchTerm={value}
        load={searchLoad}
        results={searchResult}
        recent={recentSearch}
        searchFilter={searchFilter}
        onChange={onSearchHandler}
        setSearchTerm={setValue}
        setSearchLoad={setSearchLoad}
        {...props}
      />
    </Box>
  );
};

export default PropertySearch;
